module.exports = __webpack_public_path__ + "img/magento-support-security_small.d68f68fe.jpg";